import React, { Component, Fragment } from "react";

import pdfIcon from "../../../assets/images/pdf.svg";
import isUrl from "is-url";

import {
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  Image,
  WithStore,
} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

import Loading from "../../shared/components/misc/Loading";

class AttachmentsCarousel extends Component {
  renderAttachments = () => {
    if (this.props.attachments.length === 0) return <div className="emptyState"><Loading /></div>;

    return (
      <Slider className="carouselItems">
        {
          this.props.attachments.sort((a, b) => a.id > b.id).map((attachment, i) => {
            return (
              <Slide
                index={i}
                key={attachment.id}
                innerClassName="slide"
              >
                {this.renderFile(attachment)}
              </Slide>
            )
          })
        }
      </Slider>
    )
  }

  renderFile = (attachment) => {
    const url = isUrl(attachment.url) ? attachment.url :
      `${process.env.REACT_APP_API_BASE_URL}${attachment.url}`;

    return attachment.name.split('.').pop() === 'pdf' ?
      <div className="pdf">
        <img style={{"height":"5rem"}} src={ pdfIcon } alt="File" />
        <p className="description">{attachment.name}</p>
      </div> :
      <Image
        className="image"
        src={`${url}`}
        name={attachment.name}
      />;
  }

  renderControls = () => {
    return (
      <div className="carouselControls">
        <ButtonBack className="ds-btn _icon -secondary">
          <i className="materialIcon">keyboard_arrow_left</i>
        </ButtonBack>
        <ButtonNext className="ds-btn _icon -secondary">
          <i className="materialIcon">keyboard_arrow_right</i>
        </ButtonNext>
      </div>
    )
  }

  render() {
    return(
      <Fragment>
        <div className="cardTitle">Documents</div>
        {this.renderAttachments()}
        {this.props.attachments.length > 1 && this.renderControls()}

        <span className="itemIndicator">
          {this.props.currentSlide + 1 } / {this.props.attachments.length}
        </span>
      </Fragment>
    )
  }
}

export default WithStore(AttachmentsCarousel, state => ({
  currentSlide: state.currentSlide
}));




// WEBPACK FOOTER //
// ./src/features/trade_documents/components/AttachmentsCarousel.js